import { Link } from "@/i18n/routing"
import { useRef, useEffect, useState } from "react"

import IconLogo from "./IconLogo"
import { useIsMobile } from "@/hooks/useGlobalStore"

export default function SpectraLogo({ className }: { className?: string }) {
  const textRef = useRef<HTMLHeadingElement>(null)
  const [iconSize, setIconSize] = useState(16)
  const isMobile = useIsMobile()

  useEffect(() => {
    if (textRef.current) {
      const computedStyle = window.getComputedStyle(textRef.current)
      const fontSize = parseFloat(computedStyle.fontSize)
      setIconSize(fontSize / 1.5)
    }
  }, [])

  return (
    <Link href="/">
      <h1 ref={textRef} className={`flex font-glacialIndifference text-2xl tracking-[5px] ${className}`}>
        spectr
        <IconLogo className="translate-y-[11px]" style={{ width: `${iconSize}px`, height: `${iconSize}px` }} />
      </h1>
    </Link>
  )
}
